module.exports = __webpack_public_path__ + "img/background-login.e6b42633.jpg";